import easydropdown from 'easydropdown-a11y'
import { useEffect, useRef } from 'react'
import { useAppState, useAppDispatch } from './Context'

function LocationSelect() {
  const dispatch = useAppDispatch()
  const { locations, selectedLocation } = useAppState()
  const ref = useRef()
  const eddRef = useRef()

  useEffect(() => {
    if (ref.current) {
      const edd = easydropdown(ref.current, {
        behavior: {
          liveUpdates: true,
        },
      })

      eddRef.current = edd
    }

    return () => {
      eddRef.current.destroy()
    }
  }, [ref])

  const handleChange = (e) => {
    const selectedLocation = locations.find((x) => x.id === parseInt(e.target.value, 10))

    if (selectedLocation) {
      dispatch({ type: 'setSelectedLocation', payload: selectedLocation })
    }
  }

  return (
    <form className="text-base bg-white rounded-md border border-olive styled-dropdown-simple">
      <select name="location" value={selectedLocation ? selectedLocation.id : ''} ref={ref} onChange={handleChange}>
        <option value="" data-placeholder>
          Select Location
        </option>

        {locations.map((location) => (
          <option key={location.id} value={location.id}>
            {location.title}
          </option>
        ))}
      </select>
    </form>
  )
}

export default LocationSelect
